import style from "./style.module.css";
export const ErrorDialog = ({modalRef, message}) => {

    return (
        <dialog ref={modalRef} id={style.dialog_modal}>
            <p className={style.modalMsg}>{message}</p>
        </dialog>
    )
}